<template>
	<paginated-search v-bind="{ schema, searchEntities, openEntity, createEntity, autoEnable: true }"></paginated-search>
</template>

<script>
	import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
	import Course from "@/models/course.model.vue";

	export default {
		components: {
			PaginatedSearch,
		},
		data () {
			return {
				schema: Course.getSchema(),
			};
		},
		methods: {
			openEntity(entity) {
				this.$router.push(`/cursos/${entity.id}`);
			},
			createEntity() {
				this.$router.push(`/cursos/novo`);
			},
			searchEntities(paginationParameters) {
				return Course.search(paginationParameters);
			},
		},
	}
</script>